import { StringKey } from '../../lang/index';

export enum GraphVariant {
  OWNERSHIP = 'ownership',
  OWNERSHIP_PERCENT = 'ownership-percent',
  VALUATION = 'valuation',
}

export const graphVariantTitle: Record<GraphVariant, StringKey> = {
  [GraphVariant.VALUATION]: 'VALUATION_HISTORY',
  [GraphVariant.OWNERSHIP]: 'OWNERSHIP_HISTORY',
  [GraphVariant.OWNERSHIP_PERCENT]: 'OWNERSHIP_HISTORY_PERCENT',
};

export const graphVariantTitleMobile: Record<GraphVariant, string> = {
  [GraphVariant.VALUATION]: 'Valuation',
  [GraphVariant.OWNERSHIP]: 'Ownership',
  [GraphVariant.OWNERSHIP_PERCENT]: 'Ownership %',
};

export const graphVariantMap = Object.entries(graphVariantTitle);
export const graphVariantMobileMap = Object.entries(graphVariantTitleMobile);
